import React, { useMemo } from 'react'

import ReactMarkdown from 'react-markdown'
import {
    ContainerImagemVazada,
    ImagemVazada,
    CardTexto,
    CardTitulo,
} from './styles'

const CardImagemVazada = ({ card }) => {
    const { imagem, titulo, descricao, alinhamento } = card

    const hasTitle = useMemo(() => {
        if (!titulo) return null
        return (
            <CardTitulo>
                {' '}
                <ReactMarkdown>{titulo}</ReactMarkdown>{' '}
            </CardTitulo>
        )
    }, [titulo])

    const hasImage = useMemo(() => {
        if (!imagem) return null
        return (
            <ImagemVazada
                src={imagem.url}
                alt={imagem.description}
                title={imagem.title}
            />
        )
    }, [imagem])
    const hasDescription = useMemo(() => {
        if (!descricao) return null
        return (
            <CardTexto alinhamento={alinhamento}>
                {' '}
                <ReactMarkdown>{descricao}</ReactMarkdown>{' '}
            </CardTexto>
        )
    }, [alinhamento, descricao])

    return (
        <ContainerImagemVazada>
            {hasImage}
            {hasTitle}
            {hasDescription}
        </ContainerImagemVazada>
    )
}

export default CardImagemVazada
